import React from 'react';

import { useAuth } from "../../hooks/usehooks.com/use-auth";

import Authenticated from './Nav/Authenticated';
import Unauthenticated from './Nav/Unauthenticated';

export default function Nav() {
  const {user} = useAuth();
  return user ? <Authenticated /> : <Unauthenticated />
}
